/*
 * EapApp.tsx
 *
 * Created by Dr. Maximillian Dornseif 2021-11-09 in huWaWi3 24.0.2
 * Copyright (c) 2021, 2022 HUDORA GmbH
 */

import { ISidebarProps, WithSidebar } from 'fluentui-hooks'
import gql from 'graphql-tag'
import { useLocation } from 'wouter'

import {
  ANMERKUNG_FRAGMENT,
  ITEM_FRAGMENT,
  ITEM_PIM_FRAGMENT,
  PIM_FRAGMENT,
  PREIS_FRAGMENT,
  PRODUKT_FRAGMENT,
  SKUM_FRAGMENT,
  SKUM_PIM_FRAGMENT,
  SKUSUM_FRAGMENT,
  SKU_FRAGMENT,
  SKU_PIM_FRAGMENT,
} from '../fragments'
import { KindListePaginated } from '../lib/components/KindListePaginated'
import { ITEM_PIM_MUTATION, ItemsApp } from './EapItemsApp'
import { ProdukteApp } from './EapProdukteApp'
import { SkuMastersApp } from './EapSkuMastersApp'
import { SkusApp } from './EapSkusApp'

export const EapApp = (props) => {
  const [location, navigate] = useLocation()
  if (location === '/eap') {
    navigate(location.replace('/eap', '/eap/prod'))
  }

  return (
    <div>
      https://eap3.hudora.de/
      <WithSidebar items={SIDEBAR} />
    </div>
  )
}

export const ITEM_DETAIL_LIST_QUERY = gql`
  query ItemListDetailQuery($cursor: String) {
    nodes: h3ItemPages(after: $cursor, filter: { ist_aktiv: { eq: true } }) {
      edges {
        cursor
        node {
          ...itemFragment
          skuSum {
            ...skuSumFragment
          }
          preisResolved {
            ...preisLFragment
          }
          pim {
            ...itemInfoFragment
          }
          anmerkung {
            ...anmerkungFragment
          }
          produkt {
            ...produktFragment
            pim {
              ...produktInfoFragment
            }
            anmerkung {
              ...anmerkungFragment
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ITEM_FRAGMENT}
  ${SKUSUM_FRAGMENT}
  ${PREIS_FRAGMENT}
  ${ANMERKUNG_FRAGMENT}
  ${PRODUKT_FRAGMENT}
  ${PIM_FRAGMENT}
  ${ITEM_PIM_FRAGMENT}
`

export const SKUM_DETAIL_LIST_QUERY = gql`
  query SkuMasterPagesWithDetails($cursor: String) {
    nodes: h3SkuMasterPages(after: $cursor, filter: { ist_aktiv: { eq: true } }) {
      edges {
        # cursor
        node {
          ...skuMasterFragment
          pim {
            ...skuMasterInfoFragment
          }
          skuNeuste {
            ...skuFragment
            pim {
              ...skuInfoFragment
            }
          }
          item {
            id
            designator
            zusatz
            name
            produkt {
              id
              designator
              kategorie
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${SKUM_FRAGMENT}
  ${SKUM_PIM_FRAGMENT}
  ${SKU_FRAGMENT}
  ${SKU_PIM_FRAGMENT}
`

export const ITEM_PIM_LIST_QUERY = gql`
  query ItemPIMList($cursor: String) {
    nodes: h3ItemInfoPages(after: $cursor) {
      edges {
        cursor
        node {
          ...itemInfoFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${ITEM_PIM_FRAGMENT}
`

const SIDEBAR: ISidebarProps = {
  Artikel: {
    links: [
      { title: 'Produkte', path: '/eap/prod', component: <ProdukteApp /> },
      { title: 'Items', path: '/eap/item', component: <ItemsApp /> },
      {
        title: 'SKU-Master',
        path: '/eap/mastersku',
        component: <SkuMastersApp />,
      },
      { title: 'SKUs', path: '/eap/sku', component: <SkusApp /> },
    ],
  },
  Export: {
    links: [
      {
        title: 'Item komplett',
        path: '/eap/itemdetails',
        component: (
          <KindListePaginated
            title={'Items Masterliste'}
            schemaName={'H3Item'}
            listQuery={ITEM_DETAIL_LIST_QUERY}
          />
        ),
      },
      {
        title: 'SKU komplett',
        path: '/eap/masterskudetails',
        component: (
          <KindListePaginated
            title={'SKU-Master Masterliste'}
            schemaName={'H3SkuMaster'}
            listQuery={SKUM_DETAIL_LIST_QUERY}
          />
        ),
      },
    ],
  },
  Stapel: {
    links: [
      {
        title: 'ItemInfo / PIM',
        path: '/eap/itempimlist',
        component: (
          <KindListePaginated
            title={'Item-PIM'}
            schemaName={'H3ItemInfo'}
            listQuery={ITEM_PIM_LIST_QUERY}
            editMutation={ITEM_PIM_MUTATION}
            bulkEditKeyField="forDesignator"
          />
        ),
      },
    ],
  },
}
